import Nullstack from 'nullstack';
export default function IconMilitaryRank({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-military-rank",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 7v13h-10v-13l5 -3z"
  }), "   ", Nullstack.element("path", {
    d: "M10 13l2 -1l2 1"
  }), "   ", Nullstack.element("path", {
    d: "M10 17l2 -1l2 1"
  }), "   ", Nullstack.element("path", {
    d: "M10 9l2 -1l2 1"
  }), " ");
}